import React, { useState } from 'react';
import { Box, Typography, Link, Dialog, IconButton } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import { DmProject } from '../../api-services/dm-projects.client';
import ActionsFiles from '../../components/ActionsFiles';

const DealRoomTab: React.FC<{ project: DmProject }> = ({ project }) => {
    const [openPdfUrl, setOpenPdfUrl] = useState<string | null>(null);

    let reportFile = null;
    if (project?.report?.s3Key) {
        reportFile = {
            name: `Report - ${project?.report?.fileName}`,
            fileType: 'application/pdf',
            id: project.report.s3Key,
            s3Key: project.report.s3Key,
            createdAt: project?.report?.createdAt,
            sendToDealRoom: true,
        }
    }

    const files = [
        ...(reportFile ? [reportFile] : []),
        ...(project?.files
            ? project.files
                .filter(file => file.sendToDealRoom)
                .map(file => ({
                    ...file,
                    id: file.s3Key,
                }))
            : [])
    ];

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'NAME',
            flex: 2,
        },
        {
            field: 'fileType',
            headerName: 'FILE TYPE',
            flex: 1,
        },
        {
            field: 'actions',
            headerName: 'ACTIONS',
            flex: 1.5,
            sortable: false,
            renderCell: (params) => (
                <ActionsFiles file={params.row} setOpenPdfUrl={setOpenPdfUrl} />
            ),
        },
    ];

    return (
        <Box sx={{ background: '#fff', borderRadius: 2, boxShadow: 1, p: 3, mt: 2 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 32, mb: 3 }}>
                Underwriting
            </Typography>
            <DataGridPro
                rows={files}
                columns={columns}
                autoHeight
                hideFooter
                disableColumnMenu
                disableColumnFilter
                disableColumnSelector
                sx={{
                    border: 'none',
                    '& .MuiDataGrid-columnHeaders': {
                        background: '#fff',
                        fontWeight: 700,
                        fontSize: 16,
                        borderBottom: '2px solid #eee',
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: 16,
                        borderBottom: '1px solid #eee',
                    },
                    '& .MuiDataGrid-row': {
                        minHeight: 60,
                        maxHeight: 60,
                    },
                    '& .MuiDataGrid-virtualScroller': {
                        minHeight: 300,
                    },
                }}
            />
            <Dialog
                open={!!openPdfUrl}
                onClose={() => setOpenPdfUrl(null)}
                maxWidth={false}
                PaperProps={{ sx: { height: '90vh', width: '80vw' } }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                    <IconButton onClick={() => setOpenPdfUrl(null)}>
                        <span style={{ fontSize: 20, fontWeight: 700 }}>×</span>
                    </IconButton>
                </Box>
                {openPdfUrl && (
                    <iframe
                        src={openPdfUrl}
                        title="PDF Viewer"
                        width="100%"
                        height="100%"
                        style={{ flex: 1, border: 'none', minHeight: '80vh' }}
                    />
                )}
            </Dialog>
        </Box>
    );
};

export default DealRoomTab; 